import React, {useState} from 'react'
import View from './view'
import {Divisions} from '../../../constants/divisions'
import {StudyGuide} from '../../../redux/studyGuides'
import {Attempt} from '../../../redux/reportExamStatus'
import {useAppDispatch} from '../../../redux/configureStore'
import {resetDashboard} from '../../../redux/dashboard'
import {toggleErrorDialog} from '../../../redux/config'
import {useAuth} from '../../../components/AuthProvider'
import {getOrganizationCourses} from '../../../redux/courses'
import {getMember} from '../../../redux/members'

type Props = {
  division: Divisions
  courseId?: string
  studyGuides?: StudyGuide[]
  source?: 'card' | 'page'
  reportStatus?: Attempt
}

const DivisionProgress = ({
  division,
  courseId,
  studyGuides,
  source,
  reportStatus,
}: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const dispatch = useAppDispatch()
  const auth = useAuth()

  const handleResetProgress = async (
    courseId: string,
    studyGuideId: string,
  ) => {
    try {
      setIsSubmitting(true)
      const {type} = await dispatch(
        resetDashboard({auth, courseId, studyGuideId}),
      )
      if (type === resetDashboard.rejected.type) {
        setIsSubmitting(false)
        throw new Error('Failed to reset progress')
      }

      setIsSubmitting(false)

      await dispatch(getOrganizationCourses({auth}))
      await dispatch(getMember({auth}))
    } catch (e) {
      toggleErrorDialog({
        opened: true,
        error:
          'We were unable to reset your progress, please retry. If issue persists please contact our support team',
      })
    }
  }

  return (
    <View
      division={division}
      courseId={courseId}
      studyGuides={studyGuides}
      source={source}
      reportStatus={reportStatus}
      onResetProgress={handleResetProgress}
      isSubmitting={isSubmitting}
    />
  )
}

export default DivisionProgress
